<template>
  <validation-observer
    ref="form-filing-filer-status"
    tag="form"
  >
    <div class="section content">
      <div
        v-if="readOnly"
        class="columns"
      >
        <div class="column">
          <div class="message">
            <div class="message-body">
              <p>This section is disabled. Changes must be done by a system administrator.</p>
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column has-text-centered">
          <h2 class="title is-2">
            Statement Requirements
          </h2>
          <div class="subtitle is-2">
            Filers must have at least one option checked
          </div>
        </div>
      </div>
      <validation-provider
        name="Statement Requirements"
        :rules="required ? 'required' : ''"
      >
        <div class="columns is-multiline">
          <div
            v-for="requirement in requirements"
            :key="requirement.key"
            class="column is-one-third has-text-centered"
          >
            <template v-if="requirement.key !== 'mayorForm'">
              <checkbox-adv
                :id="requirement.key"
                v-model="checkedRequirements"
                :value="requirement.key"
                :disabled="readOnly || (forceState && requirement.key === 'stateForm')"
              >
                {{ requirement.label }}
              </checkbox-adv>
            </template>
          </div>
        </div>
      </validation-provider>
      <div class="section has-text-centered">
        <p
          v-if="forceState"
          class="is-small"
        >
          Most new users will need to complete at least the State form, so as of 2021 the State form is selected by default. Please contact support otherwise.
        </p>
      </div>
    </div>
  </validation-observer>
</template>
<script>
import { filerScreenHelpers } from '@/mixins/filerScreen';
import { controlValueHelpers } from '@/mixins/controlValue';
import CheckboxAdv from '@/components/phila-ui/CheckboxAdv';

export default {
  name: 'UserStatementRequirements',
  components: {
    CheckboxAdv,
  },
  mixins: [
    filerScreenHelpers,
    controlValueHelpers,
  ],
  props: {
    forceState: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: 'user',
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      profile: {
        cityForm: 'N',
        stateForm: 'N',
        mayorForm: 'N',
      },
      requirements: {},
      checkedRequirements: [],
      statementRequirementsReady: false,
    };
  },
  watch: {
    checkedRequirements: {
      async handler () {
        let reqObj = {
          cityForm: 'N',
          stateForm: 'N',
          mayorForm: 'N',
        };
        Object.keys(this.requirements).forEach(requirement => {
          if (this.checkedRequirements.includes(requirement)) {
            reqObj[requirement] = 'Y';
          }
        });
        this.$emit('requiredStatements', reqObj);
      },
    },
  },
  async created () {
    await this.initialFetch();
    await this.initialAssign();
    this.$emit('statementRequirementsReady', true);
  },
  methods: {
    async initialAssign () {
      if (this.type === 'user') {
        this.profile = await this.getUserProfile();
      } else if (this.type === 'tempUser') {
        this.profile = await this.getTempUserProfile();
      }

      this.requirements = {
        cityForm: {
          label: 'City Form',
          key: 'cityForm',
        },
        stateForm: {
          label: 'State Form',
          key: 'stateForm',
        },
        mayorForm: {
          label: 'Mayor Form',
          key: 'mayorForm',
        },
      };

      if (this.profile.cityForm === 'Y') {
        this.checkedRequirements.push('cityForm');
      }
      if (this.profile.stateForm === 'Y' || this.forceState) {
        this.checkedRequirements.push('stateForm');
      }
      if (this.profile.mayorForm === 'Y') {
        this.checkedRequirements.push('mayorForm');
      }

    },
    async initialFetch () {
      let promises = [];
      if (this.type === 'user') {
        // promises.push(this.$store.dispatch('user/fetchUserProfile'));
      } else if (this.type === 'tempUser') {
        promises.push(this.$store.dispatch('user/fetchUserProfile', this.$store.state.user.tempId));
      }
      await Promise.all(promises);
    },
    getUserProfile () {
      return this.cloneObj(this.$store.state.user.profile);
    },
    getTempUserProfile () {
      return this.cloneObj(this.$store.state.user.tempProfile);
    },
  },
};
</script>
